import { useMutation, useQueryClient } from '@tanstack/react-query';
import { toast } from 'sonner';
import { pdvApi } from './api';
import type { RegistrarVendaPayload } from './types';

export function useRegistrarVenda() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (body: RegistrarVendaPayload) => pdvApi.registrarVenda(body),
    onSuccess: () => {
      qc.invalidateQueries({ queryKey: ['caixa'] });
      qc.invalidateQueries({ queryKey: ['vendas'] });
    },
    onError: (err: Error) => toast.error(err.message),
  });
}
